import { Tooltip, Typography } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'

import { MappedChannelForAccommodation } from '../../types/reserveMonitoringList'
import useStyles from './styles/MonitoringReserveTableRow.styles'

type MonitoringReserveTableRowProps = {
  data: MappedChannelForAccommodation
  mappedChannelsForAccommodationIndex: number
}

export default function MonitoringReserveTableRow({
  data,
  mappedChannelsForAccommodationIndex
}: MonitoringReserveTableRowProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {data.channels.map((channel, channelIndex, channelArray) => (
        <Tooltip title={channel.ChannelCode} placement="top">
          <div
            className={[
              classes.subTitles,
              mappedChannelsForAccommodationIndex % 2 === 0 &&
                classes.subTitlesEven,
              channelIndex === channelArray.length - 1 && classes.lastSubTitle,
              data.accommodationName === 'Olympic Hotel' &&
                channel.ChannelCode === 'y' &&
                classes.we
            ].join(' ')}>
            <Typography className={classes.connect}>
              {channel.isConnent ? (
                <CheckIcon className={classes.checkIcon} />
              ) : (
                <ClearIcon className={classes.clearIcon} />
              )}
            </Typography>
            <div className={classes.connect}>{channel.thirty}</div>
            <div className={classes.connect}>{channel.ninety}</div>
          </div>
        </Tooltip>
      ))}
    </div>
  )
}
